import React, { useState, useEffect } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { experiences } from "../details/data";
import "../styles/Experience.css";

function ExperienceContent({
  img,
  role,
  company,
  date,
  desc,
  skills = [],
  doc = "",
  last,
  alternate,
}) {
  return (
    <TimelineItem>
      <TimelineSeparator className="timeLine">
        <span className="timeLineDot">
          <TimelineDot color="inherit">
            <img
              src={img}
              alt="company"
              style={{
                width: alternate ? "50px" : "30px",
                height: alternate ? "50px" : "30px",
                borderRadius: "50%",
              }}
            />
          </TimelineDot>
        </span>
        {!last && <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <div className="timeLineContent">
          <div className="topContent">
            <div className="topLeft">
              <img src={img} alt={company} className="companyImage" />
            </div>
            <div className="topRight">
              <h2 className="companyRole">{role}</h2>
              <p className="companyName">{company}</p>
              <p className="companyDate">{date}</p>
            </div>
          </div>
          <div className="mainContent">
            <ul className="companyDesc">
              {desc.map((line) => (
                <li className="companyDesc">{line}</li>
              ))}
            </ul>
            <div className="companySkills">
              {skills.length > 0 && <h3>Skills: </h3>}
              {skills.map((skill, index) => (
                <p key={index}>• {skill}</p>
              ))}
            </div>
          </div>
        </div>
      </TimelineContent>
    </TimelineItem>
  );
}

function Experience() {
  const [alternate, setAlternate] = useState({
    width: window.innerWidth,
    alter: window.innerWidth > 1200,
  });
  useEffect(() => {
    const resize = () => {
      setAlternate({
        width: window.innerWidth,
        alter: window.innerWidth > 1200,
      });
    };
    window.onresize = resize;

    return () => {
      window.onresize = null;
    };
  }, []);

  return (
    <section id="experience" className="experience">
      <div className="experienceHeader">
        <h1>Experience</h1>
        {experiences.length === 0 ? (
          <p></p>
        ) : (
          <p>
            My work as a software engineering student and working on different
            companies and projects
          </p>
        )}
      </div>
      <div className="experienceContent">
        {experiences.length === 0 ? (
          <p
            style={{
              color: "rgb(178, 178, 179",
              fontSize: "20px",
              margin: "20px 0px",
              textAlign: "center",
            }}
          >
            Currently I don't have any Experiences to share
          </p>
        ) : !alternate.alter ? (
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
              },
            }}
          >
            {experiences.map((job) => (
              <ExperienceContent
                img={job.img}
                company={job.company}
                date={job.date}
                desc={job.desc}
                role={job.role}
                doc={job.doc}
                skills={job.skills}
                key={job.id}
                last={job.id + 1 === experiences.length}
                alternate={alternate}
              />
            ))}
          </Timeline>
        ) : (
          <Timeline position="alternate">
            {experiences.map((job) => (
              <ExperienceContent
                img={job.img}
                company={job.company}
                date={job.date}
                desc={job.desc}
                role={job.role}
                doc={job.doc}
                skills={job.skills}
                key={job.id}
                last={job.id + 1 === experiences.length}
                alternate={alternate}
              />
            ))}
          </Timeline>
        )}
      </div>
    </section>
  );
}

export default Experience;
